import {useApi} from "./useApi";
import {JSONToMultipart} from "sv-common/helpers/jsonToMultipart";

export const useFilesApi = () => {
    const {request} = useApi();

    const upload = async (file) => request('post', `/upload`, JSONToMultipart({ files: file }, true)).then(res => res[0]);

    return { upload };
}